import axios, { type AxiosRequestConfig } from 'axios';
import axiosJWT from "./axiosClient.js";
import { InvalidTokenError, jwtDecode } from "jwt-decode";
import { useAuthStore } from '@/stores/auth';

// constants
import { BASE_URL, REFRESH } from '@/constants/api/urls';


interface JwtToken {
  name: string;
  exp: number;
  // whatever else is in the JWT.
}

const jwtInterceptor = () => {

  let refreshTokenPromise; // used to queue up requests

  axiosJWT.interceptors.request.use(
    async (config) => {
      const currentDate = new Date();

      const authStore = useAuthStore();

      const jwtAuth = authStore.getJwtAuth() as any;
      const accessToken = jwtAuth.accessToken;
            
      if (!accessToken)
        return config;

      const decodedToken = jwtDecode<JwtToken>(accessToken);

      const accessTokenValid = decodedToken.exp * 1000 >= currentDate.getTime();
      
      if (accessTokenValid) {
        console.log("Token still valid");
        
        // Now add the header
        config.headers.authorization = `Bearer ${accessToken}`;
        return config;
      }

      if (decodedToken.exp * 1000 < currentDate.getTime()) {

        // Check for in-flight refresh requests and start one if required
        refreshTokenPromise ??= getRefreshedToken(jwtAuth);
        
        const newAccessToken = await refreshTokenPromise;
        refreshTokenPromise = null; // clean in-flight state

        config.headers.authorization = `Bearer ${newAccessToken}`

      }

//      console.log('request', config);

      return config;

    },
    (error) => {

      return Promise.reject(error);
    }
  );

  const getRefreshedToken = async (jwtAuth: any) => {

    try {

      const csrfToken = jwtAuth.csrfToken;      
      const username = jwtAuth.username;  

      const params = {
        username: username
      }

      const json = JSON.stringify(params);

      const response = await axios.post(
        `${BASE_URL}${REFRESH}`,
        json, {
          headers: {
            "Content-Type": "application/json",
            "X-XSRF-TOKEN": csrfToken
          },
          withCredentials: true
      });

      const data = response.data;

      // store user details and jwt in local storage to keep user logged in between page refreshes
      localStorage.setItem('jwt_auth', JSON.stringify(data));

      return Promise.resolve(data.accessToken);

    } catch (err) {
      return Promise.reject(err);
    }

  }

};

export default jwtInterceptor;